import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUserPointsCollectionHistory } from '@/shared/model/user-points-collection-history.model';

const baseApiUrl = 'api/user-points-collection-histories';
const baseSearchApiUrl = 'api/_search/user-points-collection-histories?query=';

export default class UserPointsCollectionHistoryService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUserPointsCollectionHistory> {
    return new Promise<IUserPointsCollectionHistory>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUserPointsCollectionHistory): Promise<IUserPointsCollectionHistory> {
    return new Promise<IUserPointsCollectionHistory>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUserPointsCollectionHistory): Promise<IUserPointsCollectionHistory> {
    return new Promise<IUserPointsCollectionHistory>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
